export default __webpack_public_path__ + "static/media/thai.f9362174.png";